import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Label, Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip, makeStyles, ProgressBar, Caption1Strong, Caption2Strong, Body1Stronger, useId, Field } from "@fluentui/react-components";
import { Info20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, PulseSquare20Regular, HomePerson20Regular, LayerDiagonalPerson20Regular, PersonCircle20Regular, PanelLeftKey20Regular, ArrowUpload20Filled, ArrowUpload20Regular, Delete20Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { GlobalContext } from "../../hooks/globalContext";
import { ToastComponent } from "../../components/toast/toast.component";
import { primaryIcon, lightTheme, overflowDivider, secondaryIcon, buttonContent, dividerWidthStyle, heightResponsive, DynamicBoxingCSS, parentHome, messageTheme, warningTheme, dashboardTheme, BreadcrumbsBorder, SubSectionResponsive } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import AppConfig from "../../utility/AppConfig";
import apiCall from "../../utility/api";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../components/dialog/dialog.component";
import { convertDateToHumanReadableFormat, convertUTCToHumanReadableFormat } from "../../utility/utils";
import { deleteFunction, fetchS3Data, getStorageToken, uploadFile } from "../../api/administration/upload";
import { AdministrationPages, UploadPages } from "../../components/side_menu/InlineSidenav";
const REACT_APP_STORAGE_API_BASE = 'https://react-test.nanoheal.work/storage';

const useStyles = makeStyles({
    root: {
        maxWidth: "400px",
    },
});


const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB chunks
const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB

type responseData = {
    message: string
    link: string
    loadedIn: string
}
export const FileUploader = () => {
    const inputId = useId("input");
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isRefresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(true);
    const [final_data, set_final_data]: any = useState(null);

    const [uploadPath, setuploadPath] = useState('');

    const navigate = useNavigate();
    const { permissions } = usePermissionStore();
    const contextValue: any = useContext(GlobalContext);
    const tenantName = contextValue.tenantName || "DefaultTenant";
    const styles = useStyles();
    const handle = useFullScreenHandle();

    const [file, setFile] = useState<File | null>(null);
    const [uploadStatus, setUploadStatus] = useState<string>("");
    const [tableData, setTableData] = useState<any[]>([]);
    const [exportData, setExportData] = useState<any[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [token, setToken] = useState<any>("");
    const [overLayDataNew, setOverLayDataNew] = useState<any>({});
    const [overlayOpenNew, setOverlayOpenNew] = useState(false);
    const [deleteFile, setDeleteFile]: any = useState(false);
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [error, setError] = useState('');
    const [uploadedFileLink, setUploadedFileLink] = useState('');
    const [isToast, setIsToast] = useState(false);
    const [isSubmit, setIsSubmit] = useState(true);
    const [uploadProgress, setUploadProgress] = useState<number | null>(null);

    // const { loading, data } = useQuery(GET_STORAGE_TOKEN);
    // const [uploadFile] = useMutation(UPLOAD_FILE);

    console.log("checking the permissions------>", permissions);
    useEffect(() => {
        contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
    }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

    const tempName = localStorage.getItem('folderPath');
    var pathName = (tempName != undefined && tempName.length > 0) ? tempName : contextValue.selectedRowDetails.name;
    console.log("pathName: ", pathName)
    useEffect(() => {
        const getToken = async () => {
            try {
                const { token } = await getStorageToken();
                console.log('token:', token);
                setToken(token);
                await fetchTableData(token, pathName);
            } catch (error) {
                console.error('Error fetching token:', error);
            }
        };

        getToken();
    }, []);

    // Handle File Selection

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        // setuploadPath(event.currentTarget.value)
        if (selectedFile) {
            setFile(selectedFile);
            setUploadStatus("");
        }
        getStorageToken();
        setIsSubmit(false);
    };

    // Trigger File Input
    const triggerFileInput = () => {
        fileInputRef.current?.click();
    };

    const handleUpload = async () => {
        setIsSubmit(true);
        if (!file) {
            setUploadStatus("Please select a file first.");
            return;
        }

        setUploadStatus("Starting upload...");
        setUploadProgress(0);
        let filePath = localStorage.getItem('folderPath') || contextValue?.selectedRowDetails?.name || "";

        filePath = filePath.replace(/^\/+/, ""); // Remove leading slashes safely

        let fileUploadPath = filePath;

        if (uploadPath) {
            fileUploadPath = `${filePath}/${uploadPath}`;
        }
        try {
            const response = await uploadFile(
                file,
                fileUploadPath,
                token,
                (progress: number) => {
                    setUploadProgress(progress);
                    // Update status message based on progress
                    if (progress === 0) {
                        setUploadStatus("Starting upload...");
                    } else if (progress === 100) {
                        setUploadStatus("Upload complete! Processing...");
                    } else {
                        setUploadStatus(`Uploading... ${progress}%`);
                    }
                }
            );

            console.log('response: uploadFile', response);
            if (response.message === "Good") {
                setUploadStatus("File uploaded successfully!");
                setOverlayOpenNew(false);
                setIsToast(true);
                setUploadedFileLink(response.link);
                setFile(null);
                await fetchTableData(token, pathName);
                setIsSubmit(false);
            } else {
                setUploadStatus("Upload failed. Please try again.");
                setUploadProgress(null);
                setIsSubmit(false);
            }
        } catch (error: any) {
            console.error("File upload error:", error);
            setUploadStatus("Upload failed");
            setUploadProgress(null);
            setIsSubmit(false);
        }
    };

    // Fetch Table Data
    const fetchTableData = async (token: string, path: string) => {
        setLoading(true);
        try {
            // const path = "/SWD";
            const data = await fetchS3Data(token, path);
            console.log("data fetched:", data)
            if (Array.isArray(data) && data.length > 0) {
                set_final_data(data);
            } else {
                set_final_data([]);
            }
            setLoading(false);
            setRefresh(false);
        } catch (error) {
            setLoading(false);
            setRefresh(false);
            console.error("Error fetching data:", error);
            set_final_data([]);
        }
    };

    const deleteFiles = async () => {
        try {
            const fileList = contextValue.selectedRowIdInTable;
            const filePath = localStorage.getItem('folderPath') || contextValue.selectedRowDetails.name;

            if (!Array.isArray(fileList) || fileList.length === 0) {
                console.error('No files selected for deletion');
                return;
            }

            // Show loading state if you have one
            // setIsLoading(true);

            const { token } = await getStorageToken();

            await Promise.all(
                fileList.map(async (fileName) => {
                    console.log("first file: " + fileName)
                    console.log("first filePath: " + filePath)
                    console.log("first token: " + token)
                    try {
                        await deleteFunction(token, fileName, filePath);
                    } catch (error) {
                        console.error(`Error deleting file ${fileName}:`, error);
                    }
                })
            );

            contextValue.setSelectedRowIdInTable([]);
            await fetchTableData(token, filePath);

            // Optionally show success message
            // showSuccess('Files deleted successfully');

        } catch (error) {
            console.error('Error in deleteFiles:', error);
            // Optionally show error to user
            // showError('Failed to delete files');
        } finally {
            // Hide loading state if you have one
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        !deleteFile && contextValue.setSelectedRowIdInTable([]);
        !deleteFile && contextValue.setSelectedRowIdInSubTable([]);
    }, [deleteFile]);

    useEffect(() => {
        // const tempName = localStorage.getItem('folderPath');
        // const pathName = (tempName != undefined && tempName.length > 0) ? tempName : contextValue.selectedRowDetails.path;

        isRefresh && fetchTableData(token, pathName);
    }, [isRefresh])

    useEffect(() => {
        setOverLayDataNew({
            size: "medium",
            isTabs: false,

            headerTitle:
                (
                    <>
                        <Title3>
                            {'Upload Files'}
                        </Title3>
                    </>
                ),

            bodyData:
                (
                    <>
                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem grow shrink>
                                <Stack tokens={{ childrenGap: 10 }} horizontal>
                                    <StackItem grow shrink>
                                        <Stack tokens={{ childrenGap: 20 }} horizontalAlign="start">
                                            <StackItem>
                                                {<>
                                                    <Stack tokens={{ childrenGap: 10 }}>
                                                        <StackItem><Text></Text></StackItem>
                                                        <StackItem>
                                                            <Stack className={styles.root} tokens={{ childrenGap: 16 }}>
                                                                <StackItem>
                                                                    {/* <Text as="h2">Software File Upload</Text> */}
                                                                    <Label htmlFor={inputId} style={{ paddingInlineEnd: "12px" }}>
                                                                        Path upload: home/nanoheal/
                                                                    </Label>
                                                                    <Input placeholder="Add upload path" id={inputId} onChange={(e) => { setuploadPath(e.target.value) }} />
                                                                </StackItem>

                                                                <StackItem>
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                        accept=".exe,.msi"
                                                                    // disabled={isSubmit}
                                                                    />
                                                                    <Button shape="circular" onClick={triggerFileInput}>Select File</Button>
                                                                </StackItem>

                                                                <StackItem>
                                                                    <Text>
                                                                        {file ? (
                                                                            <><Body1Stronger>Selected file:</Body1Stronger> {file.name}</>
                                                                        ) : 'No file selected'}
                                                                    </Text>
                                                                </StackItem>

                                                                {/* <StackItem>
                                                                <Button shape="circular" onClick={handleUpload} disabled={!file}>
                                                                    Upload
                                                                </Button>
                                                            </StackItem> */}
                                                            </Stack>
                                                        </StackItem>
                                                    </Stack>
                                                </>
                                                }
                                            </StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                        <Stack tokens={{ childrenGap: 30 }}>
                            <StackItem><Text></Text></StackItem>
                            {uploadStatus && (
                                <StackItem>
                                    {/* <Text>{uploadStatus}</Text> */}
                                    {uploadProgress !== null && (
                                        <>
                                            <Stack>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem><Text></Text></StackItem>
                                                <Field validationMessage={`Uploading... ${uploadProgress}%`} validationState="none">
                                                    <ProgressBar max={100} value={uploadProgress} />
                                                </Field>
                                            </Stack>
                                            <FluentProvider theme={warningTheme}>
                                                <StackItem><Text>Please do not refresh or close the page until file is uploaded!</Text></StackItem>
                                            </FluentProvider>
                                        </>
                                    )}
                                </StackItem>
                            )}
                        </Stack>
                    </>
                ),

            footerData:
                (
                    <>
                        {
                            <Button
                                shape="circular"
                                appearance="primary"
                                disabled={isSubmit}
                                onClick={async () => { await handleUpload(); }}
                            >
                                Submit
                            </Button>
                        }
                        {/* {(dataInserted) && (<Badge appearance="ghost" color="success"> <Body2> Automations has been inserted successfully!</Body2> </Badge>)} */}

                    </>
                )
        });
    }, [file, overlayOpen, uploadStatus]);


    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>

                    {permissions.includes("administration_Fullaccess") || permissions.includes("administration_Fullaccess") ?
                        <StackItem>
                            <Button shape="circular" appearance="subtle" size="small" onClick={() => { setOverlayOpenNew(true); setUploadStatus(""); setFile(null) }}>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <ArrowUpload20Regular  {...primaryIcon} /> </StackItem>
                                    <StackItem> <Caption1> Upload File </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </StackItem>
                        :
                        <StackItem>
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                                <StackItem><Caption1> Upload File </Caption1></StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                        </StackItem>
                    }
                </StackItem>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setLoading(true); }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                {/* <StackItem>
                    {
                        permissions.includes("all") || permissions.includes("administrationLog_Fullaccess") || permissions.includes("administrationLog_ReadandExport") ? (
                            <>
                                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_admin_activitylog.csv`}>
                                </CSVLink>
                                <Button shape="circular" appearance="subtle" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                                <StackItem><Caption1> Export </Caption1></StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }
                </StackItem> */}
                <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {/* <Delete20Regular {...primaryIcon} />  */}
                                            {isdeletedisabled
                                                ? (<Delete20Regular {...secondaryIcon} />)
                                                : (<Delete20Regular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Delete </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Kindly verify your intent to delete the file."

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" onClick={() => { setDeleteFile(true); deleteFiles() }} size="small">Confirm</Button>
                                    </StackItem>
                                    <StackItem>
                                        <Button shape="circular" size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
    };
    // overflow set contents code ends here

    //data table column name code starts here
    var columns = [
        { key: "file_name", label: <Body1Strong>File Name</Body1Strong> },
        { key: "size", label: <Body1Strong> Size </Body1Strong> },
        { key: "date", label: <Body1Strong> Date </Body1Strong> },
    ];
    //data table column name code ends here
    const downloadFileFunction = () => {
        window.open(uploadedFileLink, '_blank')
        setIsToast(false);
    }
    const downloadButton = <Button shape="circular" appearance="primary" onClick={() => { downloadFileFunction(); }}>Download</Button>
    var tempTableData: any = [];
    useEffect(() => {
        // data table values append code starts here
        console.log("final_data=", final_data);

        final_data !== undefined && final_data !== null
            ? final_data.map((val: any, i: any) => {
                {
                    permissions.includes("all") || permissions.includes("administrationLog_ReadandExport") ?
                        val.Key != '' && tempTableData.push({
                            id: val.Key,
                            checkbox: "show",
                            //file_name: {label: <Button shape="circular" style={buttonContent} appearance="transparent" size="small" onClick={()=>{window.open(`${REACT_APP_STORAGE_API_BASE}/${val.Key}`, '_blank');}}> {val.Key} </Button>, icon: "", id: `${i}`},
                            file_name: { label: /*<Button shape="circular" style={buttonContent} appearance="transparent" size="small" onClick={()=>{window.open(`${REACT_APP_STORAGE_API_BASE}/${val.Key}`, '_blank');}}> {val.Key} </Button>*/ <Caption1> {val.Key} </Caption1>, icon: "", id: `${i}` },
                            date: { label: <Caption1>{convertDateToHumanReadableFormat(val.LastModified)}</Caption1> },
                            // date_timezoned: { label: <Button shape="circular" style={buttonContent} appearance="transparent" size="small" }> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
                            size: { label: <Caption1> {(val.Size / 1024 / 1024).toFixed(2)} MB </Caption1> },
                        })
                        :
                        val.Key != '' && tempTableData.push({
                            id: val.ID,
                            checkbox: "hide",
                            file_name: { label: <Caption1> {val.Key} </Caption1>, status: "" },
                            date: { label: <Caption1>{val.LastModified}</Caption1> },
                            // date_timezoned: { label: <Button shape="circular" style={buttonContent} appearance="transparent" size="small" }> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
                            size: { label: <Caption1> {val.Size} </Caption1> },
                        })
                }
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                            {name: "Manage", link: "/home" },
                                            {name:"Administration", link:"/manage/administration/role"},
                                            {name:"File Upload", link:"#"},
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            <FluentProvider style={heightResponsive} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal tokens={{ padding: '10px 0px 0px 0px' }}>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={UploadPages(`File${" "}Upload`)} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                {<Divider />}
                                            </StackItem>
                                        </Stack>
                                        <Stack style={heightResponsive}>
                                            <Stack><StackItem></StackItem></Stack>
                                            <Stack><StackItem></StackItem></Stack>
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay
                            overlayopen={overlayOpenNew}
                            setOverlayOpen={setOverlayOpenNew}
                            overlayData={overLayDataNew}
                        />
                        {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={`File Uploaded Successfully `} /*footer={downloadButton} */ />}
                    </StackItem>
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};